<template>
  <div id="customerMoodReportNewPage">
    <order-receipt-popup
      :order="selectedRow.order ? selectedRow.order : {}"
      :active="isReviewerOpen"
      @update:active="isReviewerOpen = $event"
    ></order-receipt-popup>
    <vs-table
      id="customerMoodReportNew"
      ref="table"
      :data="moodLedgerItems"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    ></vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-dark xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    ></vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col vs-type="flex" class="w-auto" v-for="(chip, index) in filterChips" :key="index">
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">{{ chip.name + " :" }}</span>
                      </vs-col>
                      <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                        <span class="weight-600 italic text-xsmaller text-primary">{{ chip.value }}</span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end">
              <vs-dropdown vs-trigger-click class="bg-white cursor-pointer panel-action-box-shadow">
                <div class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small">
                  <span class="mr-2 page-size-dropdown-span">{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    - {{ totalDataRow - (currentPage + 1) * itemsPerPage > 0 ? (currentPage + 1) * itemsPerPage : totalDataRow }}
                    of {{ totalDataRow }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10"><span>10</span></vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15"><span>15</span></vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20"><span>20</span></vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th style="width: 13%;"><vs-button class="p-1 weight-600" color="primary" type="flat">İşlem</vs-button></vs-th>
        <vs-th style="width: 16%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Müşteri Ad Soyad</vs-button></vs-th>
        <vs-th style="width: 11%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Telefon</vs-button></vs-th>
        <vs-th style="width: 8%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Mood</vs-button></vs-th>
        <vs-th style="width: 9%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Tutar</vs-button></vs-th>
        <vs-th style="width: 8%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Sipariş No</vs-button></vs-th>
        <vs-th style="width: 13%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Referans</vs-button></vs-th>
        <vs-th style="width: 11%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Şube</vs-button></vs-th>
        <vs-th style="width: 11%;"><vs-button class="p-1 weight-600" color="primary" type="flat">Tarih & Saat</vs-button></vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="{ 'cursor-pointer': tr.orderId }"
            :title="tr.orderId ? 'Tıklayarak siparişi görüntüleyin' : ''"
          >
            <vs-td>
              <p class="text-center">
                <vs-chip :color="rowColor(tr)" class="weight-600">
                  {{ tr.reasonLabel }}
                </vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center weight-600 text-small">{{ tr.customer && tr.customer.name ? tr.customer.name : 'İsim Belirtilmemiş' }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center font-mono weight-600 text-small">{{ tr.customer ? tr.customer.phone : '' }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center">
                <vs-chip :color="rowColor(tr)" class="weight-700">{{ tr.quantityFormatted }}</vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small" :class="rowTextClass(tr)">
                {{ tr.reasonLabel === 'Hediye Kullanımı' || tr.reasonLabel === 'Hediye İadesi' ? tr.amountFormatted : '' }}
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center font-mono text-small">{{ tr.orderId ? tr.orderId : '-' }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small" v-if="tr.relatedCustomer">
                {{ tr.relatedCustomer.name || 'İsim Belirtilmemiş' }}
                <br />
                <span class="font-mono text-xsmall">{{ tr.relatedCustomer.phone }}</span>
              </p>
              <span v-else class="text-grey">-</span>
            </vs-td>
            <vs-td>
              <p class="text-center text-small">{{ tr.branch ? tr.branch.name : '' }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small">{{ tr.date }} <br /> {{ tr.time }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import GlobalFilter from "../../GlobalFilter";
import OrderReceiptPopup from "../../OrderReceiptPopup";
import { GetMoodLedgerReport, GetMoodLedgerReportExcel } from "@/api/Reports";
import { getOrderEntries } from "@/api/Cart";

export default {
  name: "CustomerMoodReportNew",
  components: {
    PaginationDefault,
    GlobalFilter,
    OrderReceiptPopup,
  },
  data() {
    return {
      moodLedgerItems: [],
      totalDataRow: 0,
      selected: "",
      selectedRow: {},
      isReviewerOpen: false,
      tableOptions: {},
      currentPage: 0,
      itemsPerPage: 10,
      isFilterActive: false,
      filterOptions: ["branch", "customerPhoneNumber", "defaultTimeRange", "dateRange", "timeRange"],
      filterOptionNames: ["Şube", "Müşteri Telefon", "Zaman Aralığı", "Tarih", "Zaman"],
      filterChips: [],
    };
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    clearFilter() {
      // branch-balance-report-new'den bir şubeye tıklanarak gelindiyse (query'de branchId varsa),
      // o şubenin TÜM geçmişini göster (varsayılan dün/bugün kısıtlamasını uygulama) ve şube filtresini uygula.
      const branchIdFromRoute = this.$route.query.branchId ? Number(this.$route.query.branchId) : null;
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: { startDate: null, endDate: null },
        defaultTimeRange: branchIdFromRoute
          ? null
          : this.$now().getHours() >= 0 && this.$now().getHours() <= 2
            ? { name: "Yesterday", id: 0, dName: "Dün" }
            : { name: "Today", id: 1, dName: "Bugün" },
        timeRange: { startTime: null, endTime: null },
        customerPhoneNumber: null,
        branch: null,
        branchId: branchIdFromRoute,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getExcel() {
      GetMoodLedgerReportExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Kullanıcı Mood Raporu " + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
            this.$vs.notify({ color: "success", title: "Başarılı", text: "Excel Export Başarılı !" });
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Excel Export İşlemi Başarısız !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata !", text: "Sunucu Bağlantı Hatası !" });
        });
    },
    getMoodLedgerReport() {
      GetMoodLedgerReport(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.moodLedgerItems = res.data.items;
            this.totalDataRow = res.data.totalCount;
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Rapor Yüklenemedi !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata !", text: "Sunucu Bağlantı Hatası !" });
        });
    },
    rowColor(tr) {
      if (tr.reasonLabel === "Hediye İadesi") return "warning";
      return tr.direction == 1 ? "danger" : "success";
    },
    rowTextClass(tr) {
      if (tr.reasonLabel === "Hediye İadesi") return "text-warning";
      return tr.direction == 1 ? "text-danger" : "text-success";
    },
    loadOrderEntries(row) {
      getOrderEntries(row.orderId)
        .then((res) => {
          if (res && res.status === 200) {
            this.$nextTick(() => {
              this.selectedRow = { order: res.data };
              this.isReviewerOpen = true;
            });
          } else {
            this.$vs.notify({ color: "danger", title: "Hata : " + res.status, text: "Sipariş Detayı Yüklenemedi !" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata", text: "Sunucu Bağlantı Hatası" });
        });
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getMoodLedgerReport();
        });
      },
    },
    selected(val) {
      if (val && val.orderId) {
        this.loadOrderEntries(val);
      } else if (val && val.id) {
        this.$vs.notify({
          color: "warning",
          title: "Sipariş Yok",
          text: "Bu kayıt bir siparişe bağlı değil (ör. üyelik/referans ödülü), görüntülenecek sipariş detayı yok.",
        });
      }
      this.selected = "";
    },
    isReviewerOpen(val) {
      if (!val) this.selectedRow = {};
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created() {
    this.clearFilter();
  },
};
</script>

<style scoped>
#customerMoodReportNew >>> table {
  width: 100% !important;
  table-layout: auto !important;
}
#customerMoodReportNew >>> th {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
  white-space: nowrap !important;
}
#customerMoodReportNew >>> td {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
}
#customerMoodReportNew >>> .vs-chip {
  min-height: 22px !important;
  padding: 2px 8px !important;
  font-size: 0.75rem !important;
  width: auto !important;
  max-width: fit-content !important;
  margin: 0 auto !important;
}
</style>
